const normalizeState = (value, fallback = "pending") =>
  String(value || fallback).toLowerCase();

export const getArtworkProofStatus = (row = {}) => {
  const proof = row?.proof || row || {};
  const userState = normalizeState(proof?.approvals?.user?.state);
  const clientState = normalizeState(proof?.approvals?.client?.state);
  const proofStatus = normalizeState(proof?.proofStatus || proof?.status, "");

  if (
    proofStatus === "rejected" ||
    userState === "rejected" ||
    clientState === "rejected"
  ) {
    return { color: "error", label: "Changes Requested", description: null };
  }

  if (
    proofStatus === "approved" ||
    (userState === "approved" && clientState === "approved")
  ) {
    return { color: "success", label: "Approved", description: null };
  }

  if (clientState === "approved" && userState === "pending") {
    return {
      color: "info",
      label: "Client Approved",
      description: "Awaiting internal approval",
    };
  }

  if (userState === "approved" && clientState === "pending") {
    return {
      color: "info",
      label: "Internal Approved",
      description: "Awaiting client approval",
    };
  }

  return { color: "warning", label: "Pending Review", description: null };
};

export const getApprovalToast = (rows = [], decision = "approved") => {
  if (decision === "rejected")
    return "Changes requested for the artwork proof package.";

  const statuses = rows.map(getArtworkProofStatus);
  if (statuses.length && statuses.every(({ label }) => label === "Approved")) {
    return "Artwork proof package fully approved.";
  }
  if (statuses.some(({ label }) => label === "Internal Approved")) {
    return "Internal approval recorded. Awaiting client approval.";
  }
  if (statuses.some(({ label }) => label === "Client Approved")) {
    return "Client approval recorded. Awaiting internal approval.";
  }
  return "Artwork proof package approval recorded.";
};

export const getProofRowsFromResponse = (response) => {
  const candidates = [
    response?.rows,
    response?.results,
    response?.package?.rows,
    response?.packageGroup?.rows,
    response?.data?.rows,
    response?.data?.results,
    response?.data?.package?.rows,
    response?.data?.packageGroup?.rows,
  ];
  return candidates.find(Array.isArray) || [];
};
